import { FC, Fragment, useCallback, useState } from "react";
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddIcon from "@mui/icons-material/Add";
import { ResourceExplorerV2ViewFoldersDeleteDialog } from "./ResourceExplorerV2ViewFoldersDeleteDialog";
import { ResourceExplorerV2ViewFoldersRenameDialog } from "./ResourceExplorerV2ViewFoldersRenameDialog";
import { ResourceExplorerV2ViewCreateFolderOrViewDialog } from "../create-folder-or-view-dialog/ResourceExplorerV2ViewCreateFolderOrViewDialog";
import { navigationHierarchyItemNoDndKey } from "../../../sortable-tree/utils/constants";

interface ResourceExplorerViewWithFolderListItemActionsMenuProps {
  id: string;
  name: string;
  open: boolean;
  closeMenu(): void;
  anchor: HTMLElement | null;
}

export const ResourceExplorerV2ViewFolderListItemActionsMenu: FC<
  ResourceExplorerViewWithFolderListItemActionsMenuProps
> = ({ name, id, open, anchor, closeMenu }) => {
  const [openDialogType, setOpenDialogType] = useState<
    "add-view" | "rename" | "delete"
  >();

  const renameClickHandler = useCallback(() => {
    setOpenDialogType("rename");
  }, []);

  const deleteClickHandler = useCallback(() => {
    setOpenDialogType("delete");
  }, []);

  const addViewClickHandler = useCallback(() => {
    setOpenDialogType("add-view");
  }, []);

  const closeDialog = useCallback(() => {
    setOpenDialogType(undefined);
    closeMenu();
  }, [closeMenu]);

  return (
    <Fragment>
      <Menu
        open={open}
        onClose={closeMenu}
        anchorEl={anchor}
        disablePortal={false}
        {...navigationHierarchyItemNoDndKey}
      >
        <MenuItem onClick={renameClickHandler} sx={menuItemSx}>
          <ListItemIcon>
            <EditOutlinedIcon fontSize="small" sx={iconSx} />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">Rename</Typography>
          </ListItemText>
        </MenuItem>

        <MenuItem onClick={addViewClickHandler} sx={menuItemSx}>
          <ListItemIcon>
            <AddIcon fontSize="small" sx={iconSx} />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">Add view</Typography>
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={deleteClickHandler} sx={menuItemSx}>
          <ListItemIcon>
            <DeleteOutlineIcon fontSize="small" sx={iconSx} />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">Delete</Typography>
          </ListItemText>
        </MenuItem>
      </Menu>

      {openDialogType === "delete" && (
        <ResourceExplorerV2ViewFoldersDeleteDialog
          open
          id={id}
          name={name}
          closeMenu={closeDialog}
        />
      )}

      {openDialogType === "rename" && (
        <ResourceExplorerV2ViewFoldersRenameDialog
          open
          id={id}
          name={name}
          closeMenu={closeDialog}
        />
      )}

      {openDialogType === "add-view" && (
        <ResourceExplorerV2ViewCreateFolderOrViewDialog
          onClose={closeDialog}
          type="view"
          folderId={id}
        />
      )}
    </Fragment>
  );
};

const menuItemSx = {
  pl: 1,
  pr: 1.5,
};

const iconSx = {
  minWidth: 28,
};
